import styled from 'styled-components';
import { BP_TABLET_MAX, BP_MOBILE_MAX } from '../../assets/styles/breakpoints';

export default styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: space-between;
  .left-wrap {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }

  @media (max-width: ${BP_TABLET_MAX}px) {
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .right-wrap {
      button {
        margin-left: 5px;
      }
    }
  }
  @media (max-width: ${BP_MOBILE_MAX}px) {
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
  }
`;
